module.exports = __webpack_public_path__ + "img/a2-s66.e25932aa.jpg";